
import Gutter from '@/ui-kit/components/gutter';
import { StyleSizeType, StylePositionType } from '@/ui-kit/styles/enums';
import { PrismicLayoutType } from '@/constants/prismicContent';
import { getAction, SET_CONTENT_DATA } from '@/store/pro-marketplace-home/actions';
import ProMarketplaceLandingPageStoreName from '@/store/pro-marketplace-home/name';
import MetaHead from '@/mixins/MetaHead';
import ProMarketplaceHeroSection from '@/components/page-specific/pro-marketplace/landing-page/hero-section';
import ProMarketplaceStatementSection from '@/components/page-specific/pro-marketplace/landing-page/statement-section';
import ProMarketplaceCardSection from '@/components/page-specific/pro-marketplace/landing-page/card-section';
import ProMarketplaceBottomSection from '@/components/page-specific/pro-marketplace/landing-page/bottom-section';

export default {
  name: 'ProMarketplace',
  components: {
    ProMarketplaceHeroSection,
    ProMarketplaceStatementSection,
    ProMarketplaceCardSection,
    ProMarketplaceBottomSection,
    Gutter,
  },
  mixins: [MetaHead],
  data() {
    return {
      StyleSizeType,
      StylePositionType,
    };
  },
  async fetch() {
    if (this.isContentLoaded) {
      return;
    }

    const { data } = await this.getContent();

    this.meta.title = data.meta_title;
    this.meta.description = data.meta_description;

    await this.$store.dispatch(getAction(SET_CONTENT_DATA), data);
  },
  computed: {
    isContentLoaded() {
      return this.$store.state[ProMarketplaceLandingPageStoreName].isContentLoaded;
    },
  },
  methods: {
    getContent() {
      return this.$prismic.client.getSingle(PrismicLayoutType.ProMarketplaceLandingPage);
    },
  },
};
